import { Icon, Tooltip } from '@zoom/components';
import classnames from 'classnames';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { GenerateListIconProps } from './types';

const GenerateListIconComponent: React.FC<GenerateListIconProps & WithTranslation> = ({
  color,
  testId,
  kind,
  tooltipMessageKey,
  onClick,
  additionalClassName,
  t,
  size = 18,
}) => {
  const icon = (
    <Icon
      className={classnames('list-actions__icon', additionalClassName)}
      color={color}
      data-test-id={testId}
      kind={kind}
      size={size}
      onClick={onClick}
    />
  );

  return tooltipMessageKey ? (
    <Tooltip message={t(tooltipMessageKey)} placement="bottom">
      {icon}
    </Tooltip>
  ) : (
    // span to keep margin-left: 0 for the icon without tooltip
    <span>{icon}</span>
  );
};

export const GenerateListIcon = withTranslation()(GenerateListIconComponent);
